module.exports = __webpack_public_path__ + "static/thumb-shuttle-5143ce5e348f805242b8a2e78b046592.jpg";